// extracted by mini-css-extract-plugin
export var linkText = "_ne-0";